import { LocationDescriptor } from 'history';
import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';

import useStyles from './styles';

interface Props {
    name: React.ReactNode;
    price: {
        primary: React.ReactNode;
        secondary: React.ReactNode;
        minor?: MayBeNil<React.ReactNode>;
    };
    button?: MayBeNil<{
        text: React.ReactNode;
        to: LocationDescriptor;
        onClick?: () => void;
        variant?: 'outlined' | 'contained';
    }>;
    className?: string;
}

const Summary: React.FC<Props> = ({ name, price, button, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <span className={classes.name}>{name}</span>
            <div className={classes.price}>
                <span className={classes.primary}>{price.primary}</span>
                <span className={classes.secondary}>{price.secondary}</span>
                <span className={cx(classes.minor, { [classes._placeholder]: !price.minor })}>{price.minor}</span>
            </div>
            {button ? (
                <Button
                    component={Link}
                    to={button.to}
                    variant={button.variant || 'contained'}
                    fullWidth
                    disableElevation
                    disableFocusRipple
                    centerRipple
                    classes={{ root: classes.button, outlined: classes.outlined, contained: classes.contained }}
                    onClick={button.onClick}
                >
                    {button.text}
                </Button>
            ) : (
                <Button
                    component={'div'}
                    fullWidth
                    disabled
                    className={cx(classes.button, classes.text, classes._placeholder)}
                />
            )}
        </div>
    );
};

export default Summary;
